import { fetchRetry } from "$lib/helpers";

export async function getGeoLocation() {
  const location = await fetchRetry("https://api.ipgeolocation.io/ipgeo?apiKey=4e398c32d6184ee89165758d4359198e", {method: "GET"}, {retries: 3, retryDelay: 1000})
    .then((res) => res.json())
    .catch(() => null);
  if (location && location.ip) {
    const coma = location.ip.indexOf(",");
    if (coma !== -1) {
      location.ip = location.ip.substring(0, coma);
    }
    location.latitude = parseFloat(location.latitude);
    location.longitude = parseFloat(location.longitude);
  }
  return location;
}